import React from 'react';
import { MailIcon } from 'lucide-react';
import { BRAND, CONTACT_EMAIL, PRODUCT_NAME } from '../data/salesContent';
export function SiteFooter() {
  return <footer className="border-t border-zinc-800 bg-zinc-950 px-5 py-12" data-id="element-178" data-mp="3racdildve2yv">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-6 text-center md:flex-row md:justify-between md:text-left" data-id="element-179" data-mp="3mg82nr1hhasi">
        <div data-id="element-180" data-mp="3hgls5pd1i8ne">
          <p className="font-display text-xl font-extrabold tracking-wide text-zinc-50" data-id="element-181" data-mp="3dguur2t0cu9w">{BRAND}</p>
          <p className="mt-2 text-sm text-zinc-400" data-id="element-182" data-mp="38hroxg57ek0v">© 2026 {BRAND} · {PRODUCT_NAME} · Todos los derechos reservados.</p>
        </div>
        <div className="md:text-right" data-id="element-183" data-mp="33jq52szyegoc">
          <p className="text-sm text-zinc-400" data-id="element-184" data-mp="33krhp1wmbb86">¿Tenés alguna consulta sobre el producto?</p>
          <a href={`mailto:${CONTACT_EMAIL}`} className="mt-1 inline-flex items-center gap-2 rounded text-base font-semibold text-amber-400 transition-colors duration-150 hover:text-amber-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400/50" data-id="element-185" data-mp="2yleuuh5qy45l">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-186" data-mp="15ptv6pwr3muu" />
            {CONTACT_EMAIL}
          </a>
        </div>
      </div>
    </footer>;
}